import { render } from "./PatientTags.vue?vue&type=template&id=492d9500&scoped=true"
import script from "./PatientTags.vue?vue&type=script&lang=js"
export * from "./PatientTags.vue?vue&type=script&lang=js"

import "./PatientTags.vue?vue&type=style&index=0&id=492d9500&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492d9500"]])

export default __exports__